import '../../style/index.less';
import './index.less';

// style dependencies
import '../../select/style';
import '../../input/style';